// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"36":"MarketTrendsPage.loadable","161":"PriceMyRentalResultsPage.loadable"}[chunkId] || chunkId) + "." + {"36":"3686b7e2","161":"6ee34a1b","355":"5b4c985c","914":"8b0e96cf"}[chunkId] + ".js";
};